export class IdentificationNewUserError {
    public name1: Array<string> = [];
    public document1: Array<string> = [];
    public email: Array<string> = [];
    public legal_personality: Array<string> = [];
    public name2: Array<string> = [];
    public document2: Array<string> = [];
    public telephone: Array<string> = [];
    public date_of_birth: Array<string> = [];
    public gender: Array<string> = [];
    public password: Array<string> = [];
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/models/errors/identification-new-user.error.ts